<template>
        <yandex-map v-if="!loading"
            :coords="(this.obj.lat && this.obj.lon) ? [this.obj.lat, this.obj.lon] : currentPosition"
            :zoom="15"
            :controls="['typeSelector', 'fullscreenControl', 'zoomControl', 'rulerControl']"
        >
            <ymap-marker marker-id="marker"
                :coords="(this.obj.lat && this.obj.lon) ? [this.obj.lat, this.obj.lon] : currentPosition"
                :icon="markerIcon"
                :options="{draggable: true}"
                @dragend="onDragend"
            >
            </ymap-marker>
        </yandex-map>
</template>

<script>

export default {
    name: "yandexMaps",

    props: {
        obj: Object,
    },

    computed: {
        markerIcon() {
            return {
                layout: 'default#image',
                imageHref: '/pin.png',
                imageSize: [35, 80],
                imageOffset: [-22, -55]
            }
        },
        coords() {
            return { lat: this.obj.lat, lon: this.obj.lon };
        },
    },

    created() {
        // if (!this.obj.lat || !this.obj.lon) {
        //     navigator.geolocation.getCurrentPosition(
        //         (position) => {
        //             this.currentPosition = [position.coords.latitude, position.coords.longitude]
        //         },
        //         function (error) {
        //         }
        //     )
        // }
    },

    data() {
        return {
            loading: false,
            currentPosition: [61.7849, 34.3469],
        }
    },

    methods: {
        onDragend(e) {
            const coords = e.get("target").geometry.getCoordinates();
            this.obj.lat = coords[0]
            this.obj.lon = coords[1]
        },
    },

    // watch: {
    //     coords: {
    //         deep: true,
    //         handler(newValue, oldValue) {
    //             this.loading = true;
    //             setTimeout(()=>{
    //                 this.loading = false; 
    //             }, 1)
    //         }
    //     }
    // },
}
</script>

<style>
.ymap-container {
    height: 100%;
}
</style>
